import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface User {
  id: string
  email: string
  firstName: string
  lastName: string
  role: string
  tenantId?: string
}

interface AuthState {
  isAuthenticated: boolean
  user: User | null
  token: string | null
  mfaRequired: boolean
  loading: boolean
  error: string | null
  sessionRestored: boolean
}

const storedToken = localStorage.getItem('token')

const initialState: AuthState = {
  isAuthenticated: false,
  user: null,
  token: storedToken,
  mfaRequired: false,
  loading: false,
  error: null,
  sessionRestored: !storedToken,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true
      state.error = null
    },
    loginSuccess: (state, action: PayloadAction<{ user: User; token: string }>) => {
      state.isAuthenticated = true
      state.user = action.payload.user
      state.token = action.payload.token
      state.loading = false
      state.mfaRequired = false
      state.sessionRestored = true
      localStorage.setItem('token', action.payload.token)
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.loading = false
      state.error = action.payload
    },
    requireMfa: (state) => {
      state.mfaRequired = true
      state.loading = false
    },
    logout: (state) => {
      state.isAuthenticated = false
      state.user = null
      state.token = null
      state.mfaRequired = false
      state.sessionRestored = true
      localStorage.removeItem('token')
    },
    clearError: (state) => {
      state.error = null
    },
  },
})

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  requireMfa,
  logout,
  clearError,
} = authSlice.actions

export default authSlice.reducer
